import { Badge } from '@capawesome/capacitor-badge';
import { isNative } from './platform';

export const syncBadgeCount = async (count: number): Promise<void> => {
  if (!isNative) return;
  try {
    if (count > 0) {
      await Badge.set({ count });
    } else {
      await Badge.clear();
    }
  } catch (e) {
    // badge API unavailable
  }
};
